import styled from '@emotion/styled';
import { colors } from 'ui_system/compass/utils/theme';

interface CheckboxBrandColorProps {
  brandColor?: string;
}

export const CheckboxButton = styled.input<CheckboxBrandColorProps>`
  appearance: none;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  border: 1px solid ${colors.borderAction};
  &:checked {
    background: ${(props) => props.brandColor || colors.primary};
    border: 1px solid ${(props) => props.brandColor || colors.primary};
    fill: white;
  }
  &:checked + svg {
    opacity: 1;
    width: 10px;
    fill: white;
  }
  &:focus {
    border: 1px solid ${(props) => props.brandColor || colors.borderFocus};
  }
`;

export const CheckboxWrapper = styled.div`
  display: inline-flex;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: baseline;
  position: relative;
  flex-flow: wrap;
  svg {
    opacity: 0;
    width: 10px;
    pointer-events: none;
    position: absolute;
    left: 7px;
    top: 8px;
  }
`;

export const CheckboxText = styled.span<CheckboxBrandColorProps>`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  a {
    color: ${(props) => props.brandColor};
  }
`;

export const TextContainer = styled.div``;
